import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import ReactDatePicker from 'react-datepicker';
import Message from './ValidationMessage';
import InlineField from './InlineField';
import { noop } from 'lodash';
import { getParticularPreferenceSettings } from '../../../../common/selectors/preference';

class DatePicker extends Component {
  render() {
    let {
      dateFormat,
      intl,
      translation,
      input,
      label,
      required,
      disabled,
      isClearable = true,
      placeholder,
      displayType,
      maxDate = null,
      minDate = null,
      meta: { touched,
        error,
        warning
      }
    } = this.props;

    if (intl && translation) {
      const labelObj = translation.label;
      const placeholderObj = translation.placeholder;
      if (labelObj && labelObj.message) {
        label = intl.formatMessage(labelObj.message, labelObj.params);
      }
      if (placeholderObj && placeholderObj.message) {
        placeholder = intl.formatMessage(
          placeholderObj.message,
          placeholderObj.params,
        );
      }
    }

    let date = null;

    let showError = touched && error ? 'error' : '';
    let disabledLabel = disabled ? "disabled" : "";
    let requiredLabel = required ? "required" : "";

    if (moment(input.value).isValid()) {
      date = moment(input.value).startOf('day');
    }

    if (moment(maxDate).isValid()) {
      maxDate = moment(maxDate).endOf('day');
    }

    if (moment(minDate).isValid()) {
      minDate = moment(minDate).startOf('day');
    }

    input.value = date;

    if ( displayType === 'inline' ) {
      return <InlineField fieldType='renderDatePickerField' content={ date ? intl.formatDate(date) : null } label={label} />;
    }

    return (
      <div className={`${requiredLabel} ${disabledLabel} field ${showError} datetime fullwidth`}>
        {label && <label>{label}</label>}
        <ReactDatePicker
          {...input}
          onBlur={noop}
          isClearable={isClearable}
          placeholderText={placeholder}
          disabled={disabled}
          required={required}
          selected={date}
          maxDate={maxDate}
          minDate={minDate}
          dateFormat={dateFormat}
        />
        <Message show={touched} message={error} />
        <Message show={touched} message={warning} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const dateFormat = (
    getParticularPreferenceSettings(state, 'date_format', ['value']) || {}
  ).value;

  return {
    dateFormat
  }
}

export const DatePickerField = connect(mapStateToProps)(DatePicker);

